import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./api/apiSlice";
import authHostReducer from "application/features/hostAuth/authHostSlice";
import hostReducer from "application/features/host/hostSlice";
import propertyReducer from "application/features/property/propertySlice";
import holidayPackageReducer from "application/features/holidayPackage/holidayPackageSlice";
import calendarReducer from "application/features/calendar/calendarSlice";
import bookingsReducer from "application/features/bookings/bookingsSlice";
import expericeReducer from "application/features/experience/experienceSlice";
import clientReducer from "application/features/client/clientSlice";
import clientAuthtReducer from "application/features/clientAuth/authClientSlice";
import chatReducer from "application/features/chat/chatSlice";
import searchReducer from "application/features/search/searchSlice";
import borghiReducer from "application/features/borghi/borghiSlice";
import reviewReducer from "application/features/review/reviewSlice";
import guestsReducer from "application/features/guests/guestsSlice";
import {
  persistReducer,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  version: 4,
  storage,
  migrate: (state, version) => {
    // Handle undefined state (first time load or corrupted state)
    if (!state) {
      return Promise.resolve({
        authclient: {},
        bookings: {
          bookings: [],
          range: 3
        },
        holidayPackage: {
          holidayPackage: null,
          editingHolidayPackage: null,
          holidayPackageList: null,
          availability: null,
        },
        property: {
          property: null,
          editingProperty: null,
          propertyList: null,
          availability: null,
        },
        experience: {
          experience: null,
          experiencesList: [],
          editingExperience: null,
        },
      });
    }

    // Migration from version 1 to 2
    if (version < 2) {
      // Initialize bookings if it doesn't exist
      if (!state.bookings) {
        state.bookings = {
          bookings: [],
          range: 3
        };
      }
    }

    // Migration from version 2 to 3
    if (version < 3) {
      // Initialize holidayPackage if it doesn't exist
      if (!state.holidayPackage) {
        state.holidayPackage = {
          holidayPackage: null,
          editingHolidayPackage: null,
          holidayPackageList: null,
          availability: null,
        };
      }
    }

    // Migration from version 3 to 4
    if (version < 4) {
      // Initialize property if it doesn't exist
      if (!state.property) {
        state.property = {
          property: null,
          editingProperty: null,
          propertyList: null,
          availability: null,
        };
      }
      // Initialize experience if it doesn't exist
      if (!state.experience) {
        state.experience = {
          experience: null,
          experiencesList: [],
          editingExperience: null,
        };
      }
    }

    return Promise.resolve(state);
  }
};

const reducer = combineReducers({
  authclient: clientAuthtReducer,
  bookings: bookingsReducer,
  holidayPackage: holidayPackageReducer,
  property: propertyReducer,
  experience: expericeReducer
});

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    hostAuth: authHostReducer,
    host: hostReducer,
    events: calendarReducer,
    client: clientReducer,
    chat: chatReducer,
    search: searchReducer,
    borghi: borghiReducer,
    review: reviewReducer,
    guests: guestsReducer,
    persistedReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(apiSlice.middleware),
  devTools: true
});


